<script>
export default {
  props: {
    module: {
      type: Object,
    },
  },
  methods: {
    handlerSubmit() {
      this.module.submit()
        .catch(() => {
          this.$notify.error('Тур не найден');
        });
    },

    getMax(item) {
      if (this.module.parent.donUseTariff)
        return 100;
      const count = this.module.quota - this.module.totalQuota + item.sumTourist;
      return Math.floor(count / item.tourist);
    },

    getNameTariff(item) {
      if (this.module.parent.donUseTariff)
        return 'Добавить человека'
      return item.label
    },
    disabledButton(item) {
      const inCorrectPrice = item.price <= 0;
      return inCorrectPrice;
    },
    add(item) {
      this.module.add(item);
    },
    remove(item) {
      this.module.remove(item);
    },
    disabledItem(item) {
      console.log(`disabledItem ${this.module.quota} ${this.module.totalQuota} ${item.sumTourist} ${item.tourist} ${item.count}`)

      if (this.module.quota === 0) {
        return false;
      }

      const count = this.module.quota - this.module.totalQuota + item.sumTourist;
      const max = Math.floor(count / item.tourist);
      const total = item.tourist * (item.count + 1)
      return max < total;
    },
  },
};
</script>
<template>
  <Card class="p-t-c-ita">
    <CardTitle>
      Тарифы
    </CardTitle>
    <table
      class="mag-tour-tariffs-table p-t-c-ita__table"
      cellspacing="0"
      cellpadding="0"
      border="0"
    >
      <colgroup>
        <col>
        <col width="100">
        <col width="140">
        <col width="120">
      </colgroup>
      <thead>
      <tr>
        <th style="text-align: left">Название</th>
        <th>Цена</th>
        <th>Количество</th>
        <th>Итого</th>
      </tr>
      </thead>
      <tbody>
      <tr
        v-for="item in module.items"
        :key="item.value"
      >
        <td>{{getNameTariff(item)}}</td>
        <td class="p-t-c-ita__center">
          <span>{{ item.price | price }} {{'RUB' | currency}}</span>
        </td>
        <td>
<!--          <el-input-number-->
<!--            size="small"-->
<!--            v-model="item.count"-->
<!--            @change="handlerSubmit"-->
<!--            :min="0"-->
<!--            :max="getMax(item)"-->
<!--          />-->

          <div style="display: flex">
            <el-button
              size="mini"
              type="primary"
              :disabled="disabledButton(item)"
              @click="remove(item)" circle> - </el-button>
            <div class="p-t-c-i__additional-service-count">{{item.count}}</div>
            <el-button
              type="primary"
              size="mini"
              @click="add(item)" circle
              :disabled="disabledItem(item)" > + </el-button>
          </div>
        </td>
        <td class="p-t-c-ita__center">
          <span v-if="item.sum">{{ item.sum | price }} {{'RUB' | currency}}</span>
        </td>
      </tr>
      </tbody>
      <tr class="p-t-c-ita__total">
        <td></td>
        <td></td>
        <td>Итого:</td>
        <td class="p-t-c-ita__center">{{ module.total | price }} {{'RUB' | currency}}</td>
      </tr>
    </table>
    <div class="mag-tour-tariffs-items">
      <div v-for="item in module.items" :key="item.value">
        <span>{{ item.label }}</span>
        <br/>
        <span>Цена: {{ item.price | price }} {{'RUB' | currency}}
        <el-input-number
          size="small"
          v-model="item.count"
          @change="handlerSubmit"
          :min="0"
          :max="getMax(item)"
        /></span>
        <span v-if="item.sum">Сумма: {{ item.sum | price }} {{'RUB' | currency}}</span>
        <hr/>
      </div>
      <span><b>ИТОГО: {{ module.total | price }} {{'RUB' | currency}}</b></span>
    </div>
  </Card>
</template>
<style lang="scss">
  .p-t-c-ita {
    &__table {
      width: 100%;
      table-layout: fixed;
      border-collapse: separate;
       button {
         width: 34px;
         height: 34px;
         background: rgba(27, 94, 32, 0.6);
         color: black;
         font-size: 20px;
         border-color: rgba(27, 94, 32, 0.6);
       }
      .p-t-c-i__additional-service-count {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        width: 40px;
        padding-top: 3px;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        gap: 10px;
      }
      tbody {

        tr {
          &:nth-child(2n) {
            background: #33333311;
          }
        }

        td {
          padding: 4px 8px;
        }
      }

      thead {
        th {
          padding: 4px 8px;
          background: #33333333;
        }
      }
    }

    &__center {
      text-align: center;
    }

    &__total {
      background: none;
      text-align: right;
      font-size: 18px;

      td {
        padding: 8px;
      }
    }

    .el-input-number {
      width: 100%;

    }
  }

  @media only screen and (max-width: 499px) {

    .mag-tour-tariffs-table {
      display: none;
    }
  }

  @media only screen and (min-width: 500px) {

    .mag-tour-tariffs-items {
      display: none;
    }
  }

  @media (max-width: 500px) {
    .p-t-c-ita {
      .col-span--6 {
        width: 100%;
      }
    }
  }
</style>
